// The following eslint rule is disabled because console, FormData, and Blob are used in this file. These are globals that are available in the browser environment.
/* eslint-disable no-undef */
/**
 * Used to make requests to unauthorized endpoints that are not part of the standard SummIT authorization flow.
 */

import axios from 'axios';
import { generatePath } from 'react-router';

import { AWSConfig } from 'Config/AWSConfig';
import { TPRM_PUBLIC_LOGIN } from 'Config/PathTemplates';
import { PublicDDQBasicAuthHandler } from 'Helpers/Auth/BasicAuth/PublicDDQBasicAuthHandler';

const authHandler = new PublicDDQBasicAuthHandler();

const axiosInstance = axios.create();

axiosInstance.defaults.baseURL = AWSConfig.apiGateway.URL;

axiosInstance.interceptors.request.use((config) => {
    const basicAuthToken = authHandler.getBase64EncodedCredentials();
    const authorizationHeader = basicAuthToken === null ? {} : { Authorization: `Basic ${basicAuthToken}` };
    config['headers'] = authorizationHeader;
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.response.status === 401) {
            const session = authHandler.getAuthenticatedSession();
            authHandler.logout(session && generatePath(TPRM_PUBLIC_LOGIN, { client_id: session.client_id, third_party_id: session.third_party_id, service_id: session.service_id }));
        }
        return Promise.reject(error);
    }
);

export const publicRestApiGet = async (endpointPath, queryParameters) => {
    try {
        return await axiosInstance.get(endpointPath, {
            params: queryParameters,
        });
    } catch (error) {
        console.error(error.response);
        throw new Error(error.response.data.message);
    }
};

export const publicRestApiPost = async (endpointPath, data) => {
    try {
        return await axiosInstance.post(endpointPath, data);
    } catch (error) {
        console.error(error.response);
        throw new Error(error.response.data.message);
    }
};

export const documentUpload = async (url, fields, file, onUploadProgressCallback) => {
    const formData = new FormData();
    for (const key in fields) {
        formData.append(key, fields[key]);
    }
    formData.append('file', file);
    return axiosInstance.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
            onUploadProgressCallback(progressEvent);
        },
    });
};
